import { useIsOverflow, VERTICAL } from 'Hooks/useIsOverflow';

export const useIsVerticalOverflow = (ref, opts) => {
  return useIsOverflow(VERTICAL, ref, opts);
};
